export enum EnvironmentTypes {
  VITE_APP_ENV = 'VITE_APP_ENV',
  VITE_APP_VERSION = 'VITE_APP_VERSION',
  VITE_APP_API_KEY = 'VITE_APP_API_KEY',
  VITE_APP_GW_HOST = 'VITE_APP_GW_HOST',
  VITE_APP_ENV_COLOR = 'VITE_APP_ENV_COLOR',
  VITE_APP_DISPATCHER_URL = 'VITE_APP_DISPATCHER_URL'
}
